import { AbstractGridStrategy } from './abstract.strategy';

export class LimitedItemsGridStrategy extends AbstractGridStrategy {
    constructor(
        amount: number,
        private withPagination: boolean = false
    ) {
        super();
        this.itemsOnPage = amount;
    }

    public getGridHeight(): number {
        return 0;
    }

    public getGridPageAmount(): number {
        return this.itemsOnPage;
    }

    public showPagination(): boolean {
        return this.withPagination;
    }

    public detach() {}
    public setGridElement(gridElement: HTMLElement): void {}
}
